import { render, staticRenderFns } from "./WyhSettingSubwyh.vue?vue&type=template&id=b36c2bb6&scoped=true&"
import script from "./WyhSettingSubwyh.vue?vue&type=script&lang=js&"
export * from "./WyhSettingSubwyh.vue?vue&type=script&lang=js&"
import style0 from "./WyhSettingSubwyh.vue?vue&type=style&index=0&id=b36c2bb6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36c2bb6",
  null
  
)

export default component.exports